import {selectIsOnline} from '../../state/selectors/global';
import {getState} from '../../state/store';
import stringUtils from '../../utils/stringUtils';
import awsAuthService from '../aws/awsAuthService';
import log from '../logger/log';
import {sendRequest} from '../offlineRequestService';
import iapClientError from './iapClientError';

const formatUrl = (endpoint, path, pathParams = []) => {
    const url = new URL(endpoint);

    url.pathname += stringUtils.formatString(path, ...pathParams);

    return url.toString();
};

const createRequestConfig = async ({method, url, isAuthorized, token, body}) => {
    const config = {
        method,
        url,
        headers: {
            'Content-Type': 'application/json',
        },
    };

    if (isAuthorized) {
        const bearerToken = token ? token : await awsAuthService.getCognitoIdToken();

        config.headers.Authorization = `Bearer ${bearerToken}`;
    }

    if (body) config.data = body;

    return config;
};

const getIapData = async (args) => {
    const {
        path,
        body,
        token,
        method,
        mapping,
        endpoint,
        isCached,
        pathParams,
        isThrowError,
        isAuthorized,
        isOnlineRequest,
        isOfflineResponse,
        isLogResponse = true,
    } = args;

    let url;

    try {
        url = formatUrl(endpoint, path, pathParams);

        const config = await createRequestConfig({method, url, isAuthorized, token, body});

        log.info(`iapClient: Request has started. Method: ${method}. Url: ${url}`);

        const response = await sendRequest({
            config,
            isOffline: !selectIsOnline(getState()), // not in the service: import order matters
            isOnlineRequest,
            isOfflineResponse,
            isCached,
            args,
            logPrefix: 'iapClient',
        });

        if (isLogResponse) {
            log.debug(`iapClient: Successfully received response. Url: ${url}. Response: ${JSON.stringify(response)}`);
        } else {
            log.debug(`iapClient: Successfully received response. Url: ${url}`);
        }

        return mapping ? mapping(response) : response;
    } catch (e) {
        iapClientError.handleRequestError({e});

        log.error(`iapClient: Request failed. Url: ${url}`, e.message);

        if (isThrowError) {
            throw e;
        }
    }
};

const callGet = (params) => getIapData({method: 'get', ...params});
const callPost = (params) => getIapData({method: 'post', ...params});

export default {
    callGet,
    callPost,
};
